import React, { useState, useEffect } from "react";
import { Row, Col, Select } from "antd";
import { capitalize } from "lodash";
import { getMessagePreviewData } from "../../../Adapters/BroadcastmessageCalls";
import DateTimeFormatter from "../../../components/Utils/DateTimeFormatter";
const DraftModal = ({
    draftModalData,
    editDraftHandler,
    mainTabKey,
    messageID,
}) => {
    const { Option, OptGroup } = Select;
    const [previewData, setPreviewData] = useState("");
    const [options, setOption] = useState("");

    const [previewDataInputs, setPreviewDataInputs] = useState({
        language: "English",
        factory: null,
        subDeptId: null,
        gender: null,
        homeStates: null,
    });

    const handleValueChange = (type) => (value) => {
        setPreviewDataInputs((prevState) => ({
            ...prevState,
            [type]: value,
        }));
    };

    const getSubDeptValue = () => {
        if (previewDataInputs.subDeptId) {
            return capitalize(Object.values(previewDataInputs.subDeptId)[0]);
        }

        return null;
    };

    function toPascalCase(str) {
        return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
            return match.toUpperCase();
        });
    }

    const previewDraftData = async () => {
        if (
            previewDataInputs.language &&
            previewDataInputs.subDeptId &&
            previewDataInputs.factory &&
            previewDataInputs.gender &&
            (!draftModalData?.homeStates || previewDataInputs?.homeStates)
        ) {
            let queryUrl = new URL(
                `${process.env.REACT_APP_BASE_URL_API}/api/accounts/savedraft`
            );
            const departmentParam = JSON.stringify(previewDataInputs.subDeptId);
            queryUrl.searchParams.append("draftID", messageID);
            queryUrl.searchParams.append("department", departmentParam);
            queryUrl.searchParams.append(
                "language",
                previewDataInputs.language
            );
            queryUrl.searchParams.append("factory", previewDataInputs.factory);
            queryUrl.searchParams.append("gender", previewDataInputs.gender);
            draftModalData?.homeStates &&
                queryUrl.searchParams.append(
                    "homeStates",
                    previewDataInputs.homeStates
                );
            const res = await getMessagePreviewData(queryUrl);

            setPreviewData(res?.data.message_body);
        }
    };

    const previewMessageData = async () => {
        let category;
        if (mainTabKey === "2") {
            category = "Scheduled";
        } else {
            category = "Sent";
        }
        if (
            previewDataInputs.language &&
            previewDataInputs.subDeptId &&
            previewDataInputs.factory &&
            previewDataInputs.gender &&
            (!draftModalData?.homeStates || previewDataInputs?.homeStates)
        ) {
            let queryUrl = new URL(
                `${process.env.REACT_APP_BASE_URL_API}/api/accounts/ScheduleSentDashboards/?category=${category}`
            );
            const departmentParam = JSON.stringify(previewDataInputs.subDeptId);
            queryUrl.searchParams.append("messageID", messageID);
            queryUrl.searchParams.append("department", departmentParam);
            queryUrl.searchParams.append(
                "language",
                previewDataInputs.language
            );
            queryUrl.searchParams.append("factory", previewDataInputs.factory);
            queryUrl.searchParams.append("gender", previewDataInputs.gender);
            draftModalData?.homeStates &&
                queryUrl.searchParams.append(
                    "homeStates",
                    previewDataInputs.homeStates
                );
            const res = await getMessagePreviewData(queryUrl);

            setPreviewData(res?.data.message_body);
        }
    };

    useEffect(() => {
        if (mainTabKey === "3") {
            previewDraftData();
        } else {
            previewMessageData();
        }
        if (draftModalData) {
            const options = draftModalData?.subDepartments.reduce(
                (acc, curr) => {
                    if (!acc[curr.Department]) {
                        acc[curr.Department] = [];
                    }
                    acc[curr.Department].push(curr);
                    return acc;
                },
                {}
            );
            setOption(options);
        }
    }, [
        previewDataInputs.language,
        previewDataInputs.subDeptId,
        previewDataInputs.factory,
        previewDataInputs.gender,
        previewDataInputs.homeStates,
    ]);

    return (
        <div className="draftModalContainer">
            <Row gutter={(12, 24)}>
                <Col span={12}>
                    <Row>
                        <Col flex="2" style={{ fontWeight: "bold" }}>
                            {draftModalData?.Status === "Sent"
                                ? "Date & Time"
                                : "Last Modified"}
                        </Col>
                        <Col
                            flex="3"
                            style={{
                                marginBottom: " 2rem",
                                flexFlow: "unset",
                                borderBottom: "1px solid #BEBEBE",
                            }}>
                            {mainTabKey === "2" || mainTabKey === "4" ? (
                                <DateTimeFormatter
                                    dateTimeString={`${draftModalData?.Date} ${draftModalData?.Time}`}
                                />
                            ) : (
                                <DateTimeFormatter
                                    dateTimeString={
                                        draftModalData?.lastModified
                                    }
                                />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col flex="2" style={{ fontWeight: "bold" }}>
                            Total SMS count
                        </Col>
                        <Col
                            flex="3"
                            style={{
                                marginBottom: " 2rem",
                                flexFlow: "unset",
                                borderBottom: "1px solid #BEBEBE",
                            }}>
                            {draftModalData?.TotalSMSCount}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row gutter={(12, 24)}>
                <Col span={12}>
                    <Row>
                        <Col flex="2" style={{ fontWeight: "bold" }}>
                            {draftModalData?.Status === "Sent"
                                ? "Sent By"
                                : "Created By"}
                        </Col>
                        <Col
                            flex="3"
                            style={{
                                marginBottom: " 2rem",
                                flexFlow: "unset",
                                borderBottom: "1px solid #BEBEBE",
                            }}>
                            {draftModalData?.createdBy}
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col flex="2" style={{ fontWeight: "bold" }}>
                            Template
                        </Col>
                        <Col
                            flex="3"
                            style={{
                                marginBottom: " 2rem",
                                flexFlow: "unset",
                                borderBottom: "1px solid #BEBEBE",
                            }}>
                            {draftModalData?.Template}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row justify="start">
                <Col>
                    <Select
                        aria-label="Language"
                        data-testid="Language"
                        placeholder="Language"
                        value={previewDataInputs.language}
                        onChange={() => {
                            handleValueChange("language");
                        }}>
                        {draftModalData?.language.map((val) => (
                            <Option key={val} value={val}>
                                {val}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Select
                        aria-label="Gender"
                        data-testid="Gender"
                        placeholder="Gender"
                        value={previewDataInputs.gender}
                        defaultActiveFirstOption={false}
                        onChange={handleValueChange("gender")}>
                        {draftModalData?.Genders.map((gender, index) => (
                            <Option key={index} value={gender}>
                                {gender}
                            </Option>
                        ))}
                    </Select>
                </Col>
                {draftModalData?.homeStates && (
                    <Col>
                        <Select
                            value={previewDataInputs.homeStates}
                            placeholder="Home States"
                            onChange={handleValueChange("homeStates")}>
                            {draftModalData?.homeStates.map((val) => (
                                <Option value={val}>{val}</Option>
                            ))}
                        </Select>
                    </Col>
                )}

                <Col>
                    <Select
                        placeholder="Factory"
                        data-testid="Factory"
                        aria-label="Factory"
                        value={previewDataInputs.factory}
                        onChange={handleValueChange("factory")}>
                        {draftModalData?.Factories.map((val) => (
                            <Option key={val.id} value={val.id}>
                                {val.Code}
                            </Option>
                        ))}
                    </Select>
                </Col>
                <Col>
                    <Select
                        placeholder="Department"
                        data-testid="Department"
                        aria-label="Department"
                        value={getSubDeptValue()}
                        onChange={(value, option) => {
                            const [department, subDepartment] =
                                value.split("-");

                            handleValueChange("subDeptId")({
                                [department]: subDepartment,
                            });
                        }}>
                        {Object.keys(options)?.map((department) => (
                            <OptGroup label={department} key={department}>
                                {options[department].map((subDept) => (
                                    <Option
                                        key={`${department}-${subDept.SubDepartment}`}
                                        value={`${department}-${subDept.SubDepartment}`}>
                                        {toPascalCase(subDept.SubDepartment)}
                                    </Option>
                                ))}
                            </OptGroup>
                        ))}
                    </Select>
                </Col>
            </Row>
            <Row gutter={(12, 24)}>
                <Col span={12}>
                    <Row>
                        <Col flex="2" style={{ fontWeight: "bold" }}>
                            Message:
                        </Col>
                        <Col
                            flex="3"
                            style={{
                                marginBottom: " 2rem",
                                flexFlow: "unset",
                                borderBottom: "1px solid #BEBEBE",
                            }}>
                            {previewData?.Message ? previewData?.Message : "-"}
                        </Col>
                    </Row>
                </Col>
                <Col span={12}>
                    <Row>
                        <Col flex="2" style={{ fontWeight: "bold" }}>
                            SMS Count
                        </Col>
                        <Col
                            flex="3"
                            style={{
                                marginBottom: " 2rem",
                                flexFlow: "unset",
                                borderBottom: "1px solid #BEBEBE",
                            }}>
                            {previewData?.SMSCount >= 0
                                ? previewData?.SMSCount
                                : "-"}
                        </Col>
                    </Row>
                    {(mainTabKey === "2" || mainTabKey === "4") && (
                        <Row>
                            <Col flex="2" style={{ fontWeight: "bold" }}>
                                Time Zone
                            </Col>
                            <Col
                                flex="3"
                                style={{
                                    marginBottom: " 2rem",
                                    flexFlow: "unset",
                                    borderBottom: "1px solid #BEBEBE",
                                }}>
                                {previewData?.Timezone}
                            </Col>
                        </Row>
                    )}
                </Col>
            </Row>
            {draftModalData?.Status === "Draft" &&
            draftModalData?.editAccess === "Yes" ? (
                <>
                    <hr></hr>
                    <Row justify="end">
                        <Col>
                            <button
                                className="secondaryButton"
                                onClick={editDraftHandler}>
                                Edit
                            </button>
                        </Col>
                    </Row>
                </>
            ) : null}
        </div>
    );
};

export default DraftModal;
